import React from 'react';
import { Check, Flame, Lock, ShieldCheck } from 'lucide-react';
import { Button, Tag } from '../ui/Shared';
export function FinalCtaSection() {
  return <section id="cta-final" className="py-28 text-center relative overflow-hidden bg-[radial-gradient(ellipse_at_center,#1A2340,#0A0F1E)]" data-id="element-135">
      {/* Background overlay */}
      <div className="absolute inset-0 opacity-[0.03] bg-center bg-cover" style={{
      backgroundImage: "url('https://images.unsplash.com/photo-1493894473891-10fc1e5dbd22?w=1400&q=80')"
    }} data-id="element-136" />

      <div className="max-w-[780px] mx-auto px-6 relative z-10" data-id="element-137">
        <Tag data-id="element-138">Última oportunidad</Tag>

        <h2 className="font-playfair text-3xl md:text-5xl lg:text-[56px] font-black mb-5 leading-[1.2]" data-id="element-139">
          Recupera tus noches
          <br data-id="element-140" />
          <span className="text-gradient-gold" data-id="element-141">y tu salud digestiva.</span>
        </h2>

        <p className="text-lg text-text-muted max-w-[600px] mx-auto mb-10 leading-relaxed" data-id="element-142">
          Olvida el gasto constante en farmacias y los efectos secundarios de
          los bloqueadores de ácido. Consigue el Protocolo SOS Reflujo 11 PM por
          un acceso único y descarga inmediata.
        </p>

        <div className="scale-in bg-accent/10 border border-accent/20 rounded-xl p-7 md:px-6 max-w-[520px] mx-auto mb-9 text-left" data-id="element-143">
          <p className="text-sm text-text-muted mb-4 font-semibold uppercase tracking-widest" data-id="element-144">
            Lo que recibes hoy:
          </p>

          <div className="flex flex-col gap-2" data-id="element-145">
            <div className="flex gap-2.5 text-sm text-text-muted" data-id="element-146">
              <Check className="w-4 h-4 text-accent mt-0.5 shrink-0" data-id="element-147" />
              <span data-id="element-148">
                <strong className="text-text-light" data-id="element-149">
                  Guía Principal SOS Reflujo 11 PM
                </strong>
              </span>
            </div>
            <div className="flex gap-2.5 text-sm text-text-muted" data-id="element-150">
              <Check className="w-4 h-4 text-accent mt-0.5 shrink-0" data-id="element-151" />
              <span data-id="element-152">
                <strong className="text-text-light" data-id="element-153">Bono #1:</strong> Lista
                Negra del Reflujo
              </span>
            </div>
            <div className="flex gap-2.5 text-sm text-text-muted" data-id="element-154">
              <Check className="w-4 h-4 text-accent mt-0.5 shrink-0" data-id="element-155" />
              <span data-id="element-156">
                <strong className="text-text-light" data-id="element-157">Bono #2:</strong> Guía
                Express de Cena Sin Castigo
              </span>
            </div>
            <div className="flex gap-2.5 text-sm text-text-muted" data-id="element-158">
              <Check className="w-4 h-4 text-accent mt-0.5 shrink-0" data-id="element-159" />
              <span data-id="element-160">
                <strong className="text-text-light" data-id="element-161">Bono #3:</strong> Protocolo
                de Emergencia Anti-Agrura
              </span>
            </div>
            <div className="flex gap-2.5 text-sm text-text-muted" data-id="element-162">
              <Check className="w-4 h-4 text-accent mt-0.5 shrink-0" data-id="element-163" />
              <span data-id="element-164">
                <strong className="text-text-light" data-id="element-165">Garantía de 7 días</strong>{' '}
                sin preguntas
              </span>
            </div>
          </div>

          <div className="border-t border-white/10 mt-4 pt-4 flex justify-between items-center" data-id="element-166">
            <span className="text-[13px] text-text-muted" data-id="element-167">
              Valor total real:
            </span>
            <span className="price-struck text-[17px] font-bold" data-id="element-168">187 USD</span>
          </div>

          <div className="flex justify-between items-center mt-2" data-id="element-169">
            <span className="text-sm font-bold text-accent" data-id="element-170">
              Precio Especial:
            </span>
            <span className="price-glow font-playfair text-[38px] font-black text-gradient-gold leading-none" data-id="element-171">
              12 USD
            </span>
          </div>
        </div>

        <div className="flex justify-center" data-id="element-172">
          <Button href="https://pay.hotmart.com/S104868471X" size="large" data-id="element-173">
            <Flame className="w-5 h-5" data-id="element-174" />
            ¡Sí, Quiero Apagar el Fuego Ahora!
          </Button>
        </div>

        <div className="flex items-center justify-center gap-6 mt-6 flex-wrap" data-id="element-175">
          <span className="flex items-center gap-1.5 text-text-muted text-xs font-medium" data-id="element-176">
            <Lock className="w-3.5 h-3.5 text-accent" data-id="element-177" /> Compra 100% Segura
          </span>
          <span className="flex items-center gap-1.5 text-text-muted text-xs font-medium" data-id="element-178">
            <Check className="w-3.5 h-3.5 text-accent" data-id="element-179" /> Garantía 7 Días
          </span>
          <span className="flex items-center gap-1.5 text-text-muted text-xs font-medium" data-id="element-180">
            <ShieldCheck className="w-3.5 h-3.5 text-accent" data-id="element-181" /> Privacidad
            Protegida
          </span>
        </div>

        <p className="mt-6 text-sm text-text-muted flex items-center justify-center gap-2" data-id="element-182">
          <ShieldCheck className="w-4 h-4 text-accent" data-id="element-183" />7 días de garantía
          completa — Si no es lo que esperabas, te devolvemos tu dinero. Sin
          preguntas.
        </p>
      </div>
    </section>;
}